import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import card1 from "../../../assets/img/services/servicesTwo/card1.webp";
import card2 from "../../../assets/img/services/servicesTwo/card3.webp";
import card3 from "../../../assets/img/services/servicesTwo/card2.webp";
import card4 from "../../../assets/img/services/servicesTwo/card4.webp";
import card5 from "../../../assets/img/services/servicesTwo/card5.webp";

const serviceCards = [
  { className: "card1", img: card1, titleKey: "services_two_card1_title", textKey: "services_two_card1_text" },
  { className: "card2", img: card2, titleKey: "services_two_card2_title", textKey: "services_two_card2_text" },
  { className: "card3", img: card4, titleKey: "services_two_card3_title", textKey: "services_two_card3_text" },
  { className: "card4", img: card3, titleKey: "services_two_card4_title", textKey: "services_two_card4_text" },
  { className: "card5", img: card5, titleKey: "services_two_card5_title", textKey: "services_two_card5_text" },
];

function ServicesTwo() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <div className="servicesTwo">
      <VisibilitySensor onChange={onChange} partialVisibility minTopValue={340}>
        <div>
          <div className="servicesTwoText">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("services_two_title")}
            </h1>
            <h2 className={`${isVisible ? "visible" : ""}`}>
              {t("services_two_subtitle")}
            </h2>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("services_two_text")}
            </p>
          </div>
          <div className={`servicesTwoCards-bg ${isVisible ? "visible" : ""}`}>
            <div className="servicesTwoCards">
              {serviceCards.map(({ className, img, titleKey, textKey }) => (
                <div key={className} className={`card ${className} ${isVisible ? "visible" : ""}`}>
                  <img
                    className={`${isVisible ? "visible" : ""}`}
                    src={img}
                    alt=""
                    width={"280px"}
                  />
                  <h3 className={`${isVisible ? "visible" : ""}`}>
                    {t(titleKey)}
                  </h3>
                  <p className={`${isVisible ? "visible" : ""}`}>
                    {t(textKey)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </VisibilitySensor>
    </div>
  );
}

export default ServicesTwo;
